export const DEPARTEMENTS_LEAD_HELLIO_TRAVAUX = [
  '37',
  '29',
  '33',
  '88',
  '69',
  '86',
  '54',
];
